import { Col, Input, Row, Select, Tooltip, message, Button } from 'antd'
import React, { useState, useEffect } from 'react'
import { CSVLink } from "react-csv"
import { FileExcelFilled } from '@ant-design/icons';
import moment from 'moment';
const { Option } = Select;

const ReportFilter = ({searchHide, filter, setFilter, setPage, setOffset , headers, FilteredData, setFilteredData = (val) => { } }) => {
    const [values, setValues] = useState({
        searchString: "",
        fromDate: "",
        toDate: "",
    });
    const handleChange = (name, value) => {
        setValues({ ...values, [name]: value });
    }
    const handleFilter = () => {
        setFilter({ ...filter, ...values });
        setPage(1);
        // setOffset(0);
    }
    const handleFilterReset = () => {
        setFilter({});
        setValues({
            ...values,
            searchString: "",
            fromDate: "",
            toDate: "",
            sentStatus: "",
        })
        setPage(1);
    }

    return (

        <div className='table_filter'>
            <Row gutter={[24, 20]} className="ml-10">

                <Col md={5} sm={12} xs={24}>

                    <strong>  <p className='mb-2'>From Date</p></strong>
                    <Input
                        type="date"
                        id="fromdate"
                        autoComplete="new-off"
                        className='form-control'
                        onChange={(e) => handleChange("fromDate", e.target.value)}
                        max={moment().format("YYYY-MM-DD")}
                        placeholder='From Date'
                        value={values?.fromDate}
                    />

                </Col>

                <Col md={5} sm={12} xs={24}>
                    <strong><p className='mb-2'>To Date</p></strong>
                    <Input
                        type="date"
                        id="todate"
                        autoComplete="todate"
                        className='form-control'
                        onChange={(e) => handleChange("toDate", e.target.value)}
                        min={values?.fromDate}
                        placeholder='To Date'
                        value={values?.toDate}
                    />
                </Col>
                {!searchHide &&
                    <Col md={4} sm={4} xs={24}>
                        <strong> <p className='mb-2'>Search</p></strong>
                        <Input
                            type="text"
                            autoComplete="new-off"
                            className='form-control'
                            onChange={(e) => handleChange("searchString", e.target.value)}
                            placeholder='Search'
                            value={values?.searchString}
                        />
                    </Col>}
                    <Col md={4} sm={12} xs={24}>
                    <strong> <p className='mb-2'>Status</p></strong>
                    <Select
                        className='text-capitalize w-100'
                        placeholder='Select Status'
                        autoComplete="new-off"
                        onChange={(value) => handleChange("sentStatus", value)}
                        value={values?.sentStatus }
                    >
                        <Option className='text-capitalize' value="">All</Option>
                        <Option className='text-capitalize' value={0}>Pending</Option>
                        <Option className='text-capitalize' value={1}>Linked</Option>
                    </Select>
                </Col>
                <Col md={3} sm={12} xs={24}>
                    <div className='flex gap10 mt-20'>
                        <button className='filter-button' onClick={() => handleFilter()}>Filter</button>
                        <button className='clear-button' onClick={() => handleFilterReset()}>Reset</button>
                    </div>
                </Col>
                <Col md={2} sm={12} xs={24} className='mt-20'>
                    <CSVLink
                        filename={"Reports.csv"}
                        data={FilteredData}
                        headers={headers}
                        className="ex-export2 part-export"
                        onClick={() => {
                            message.success("The file is downloading")
                        }}
                    >
                        <Tooltip placement="top" title={"A user can download only single page data once."} arrow={false}>
                        <Button className='export-csv'> Export to CSV </Button>
                        </Tooltip>
                    </CSVLink>
                </Col>
            </Row>
        </div >
    )
}

export default ReportFilter